// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2QeLL","buttons":"Table_buttons__9_7yH","center-content":"Table_center-content__2y3hn"};